module.exports = __webpack_public_path__ + "4f4ba976469db52e907db0c46ec476c9.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-28.png
// module id = 118
// module chunks = 0